// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + chunkId + ".mp." + {"FavouritesUiDynamicBuyerInfoModal":"f35e5b4b","SmartBannerFullScreen":"f744679c"}[chunkId] + ".css");